import React from 'react';

const LoadingButton = () => {
  return (
    <button disabled className="justify-center bg-brand-500 text-white p-3 rounded-md flex items-centerflex w-full justify-center rounded-md bg-brand-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-brand-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600">
      <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" className="opacity-25"/>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M4 12a8 8 0 0116 0" className="opacity-75"/>
      </svg>
      Processing...
    </button>
  );
};

export default LoadingButton;